import { NgModule } from '@angular/core';

import { SharedDependenciesModule } from '../shared';
import { MediaModalComponent } from './media-modal/media-modal.component';

import { ViDswFooterComponent } from '../shared/+design-system-web/vi-dsw-footer/vi-dsw-footer.component';
import { UpdatesTabsComponent } from './updates-tabs/updates-tabs.component';
import { UpdatesdRouting } from './updates.routing';
import { UpdatesComponent } from './updates/updates.component';
import { ViCareUpdateComponent } from './vicare-update/vicare-update.component';
import { ViGuideUpdateComponent } from './viguide-update/viguide-update.component';

@NgModule({
  declarations: [
    UpdatesComponent,
    ViGuideUpdateComponent,
    MediaModalComponent,
    UpdatesTabsComponent,
    ViCareUpdateComponent,
  ],
  imports: [SharedDependenciesModule, UpdatesdRouting, ViDswFooterComponent],
})
export class UpdatesModule {}
